export const clearUserData = () => {
  localStorage.removeItem('SelectedNodes');
};
